import React, { useEffect, useState } from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from "@fullcalendar/interaction";

import * as Request from "../commons/request";
import * as TypeUtils from "../commons/typeUtils";
import * as String from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import styles from "../pages/RentManagement/ReservationManagement.module.css";
import moment from "moment";
import { EventContentArg } from "@fullcalendar/core";
import { useAsyncAxios, utilAxiosWithAuth } from "../utils/customAxios";

// TODO: 색상 수정 필요 - customize가 필요함. 참고 https://fullcalendar.io/demos
// TODO: select Event

function RentScheduler({
    startRents,
    endRents,
    onClickDate,
}: {
    startRents?: Utils.RentsByDate;
    endRents?: Utils.RentsByDate;
    onClickDate?: (date: string) => void;
}) {
    const [events, setEvents] = useState<Array<any>>([]);
    const [holidays, setHolidays] = useState<Array<TypeUtils.Holidays>>([]);
    const [currentYear, setCurrentYear] = useState<number>(moment().year());

    useEffect(() => {
        requestGetHolidays(currentYear);
    }, []);

    useEffect(() => {
        if (startRents === undefined || endRents === undefined) return;

        const tempEvent: any[] = [];

        const startDates = Object.keys(startRents);
        startDates.forEach((startDate) => {
            const startRentList = startRents[startDate];
            const isExist = startRentList.find((rent) => rent.rentCar.repairing === true);
            tempEvent.push({
                id: startDate + "-0",
                title: String.rent_use + String.dash + startRents[startDate].length + "건",
                allDay: false,
                start: startDate + Common.DEFAULT_USED_TIME,
                backgroundColor: isExist ? Common.COLOR_ERROR : Common.COLOR_USE,
            });
        });

        const endDates = Object.keys(endRents);
        endDates.forEach((endDate) => {
            tempEvent.push({
                id: endDate + "-1",
                title: String.rent_return + String.dash + endRents[endDate].length + "건",
                allDay: false,
                start: endDate + Common.DEFAULT_ARRIVED_TIME,
                backgroundColor: Common.COLOR_RETURN,
            });
        });
        setEvents(tempEvent);
    }, [startRents, endRents]);

    const dateClick = (info: any) => {
        onClickDate && onClickDate(info.dateStr);
    };

    const renderEventContent = (eventInfo: EventContentArg) => {
        return (
            <>
                <div className="fc-daygrid-event-dot" style={{ borderColor: eventInfo.backgroundColor }}></div>
                <div className="fc-event-title">{eventInfo.event.title}</div>
            </>
        );
    };

    const dayCellContent = (arg: any) => {
        const isHoliday = holidays.find((holiday) => holiday.date === moment(arg.date).format(Common.FORMAT_DATE));
        const isSaturday = arg.date.getDay() === 6;
        const isSunday = arg.date.getDay() === 0;

        const dayNumberTextWithoutSuffix = arg.dayNumberText.replace("일", "");

        if (isHoliday) {
            return (
                <div style={{ textAlign: "end" }}>
                    <p style={{ color: "red", margin: "0" }}>{dayNumberTextWithoutSuffix}</p>
                    <p style={{ color: "red", margin: "0", fontSize: "10px" }}>{isHoliday.dateName}</p>
                </div>
            );
        } else if (isSaturday) {
            return <span style={{ color: "blue" }}>{dayNumberTextWithoutSuffix}</span>;
        } else if (isSunday) {
            return <span style={{ color: "red" }}>{dayNumberTextWithoutSuffix}</span>;
        }

        return <span style={{ color: "black" }}>{dayNumberTextWithoutSuffix}</span>;
    };

    const handleDatesSet = (arg: any) => {
        const selectedYear = moment(arg.view.currentStart).year();

        if (currentYear !== selectedYear) {
            setCurrentYear(selectedYear);
            requestGetHolidays(selectedYear);
        }
    };

    const requestAxiosGetHolidays = async (year: string, month?: string) => {
        const response = await utilAxiosWithAuth().get(Request.RENT_HOLIDAYS_URL, { params: { year: year, month: month } });
        return response.data;
    };

    const {
        loading: loadingGetHolidays,
        error: errorGetHolidays,
        data: resultGetHolidays,
        execute: requestGetHolidays,
    } = useAsyncAxios(requestAxiosGetHolidays);

    useEffect(() => {
        if (resultGetHolidays === null) return;

        console.log("resultGetHolidays", resultGetHolidays);
        setHolidays(resultGetHolidays.holidays);
    }, [resultGetHolidays]);

    useEffect(() => {
        if (errorGetHolidays === null) return;

        console.log("errorGetHolidays", errorGetHolidays);
    }, [errorGetHolidays]);

    return (
        <FullCalendar
            locale="ko"
            height="600px"
            plugins={[dayGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            eventBackgroundColor="#5DA0E3"
            eventClassNames={styles.event}
            events={events}
            eventClick={(e) => {
                onClickDate && onClickDate(e.event.id.substring(0, e.event.id.length - 2));
            }}
            eventContent={renderEventContent}
            dateClick={dateClick}
            datesSet={handleDatesSet}
            dayCellContent={dayCellContent}
            dayHeaderContent={(arg) => <span style={{ color: "black" }}>{arg.text}</span>}
        />
    );
}

export default RentScheduler;
